import { RequiredKeysOf } from 'type-fest'
import { v4 as uuidv4 } from 'uuid'
import { OpalApiComponent, OpalApiRequestBody } from '../../schema'

type RequestAttributes =
  OpalApiRequestBody<'CreateRichTextDocumentV3'>['data']['attributes']
type RequestRelationships = {
  created_by_user: { data: { id: string; type: 'user' } }
}

type OptionalAttributes = Omit<
  OpalApiComponent<'V3', 'rich_text_document'>['attributes'],
  RequiredKeysOf<RequestAttributes>
>

const defaultBoardAttributes: OptionalAttributes = {
  created_at: new Date().toISOString(),
  updated_at: new Date().toISOString(),
}

export const resourceObject = ({
  attributes,
  relationships,
}: {
  attributes: RequestAttributes
  relationships: RequestRelationships
}): OpalApiComponent<'V3', 'rich_text_document'> => {
  return {
    id: uuidv4(),
    type: 'rich_text_document',
    attributes: {
      ...defaultBoardAttributes,
      ...attributes,
    },
    relationships: {
      ...relationships,
    },
  }
}
